export default "__VITE_PUBLIC_ASSET__da77c88b__"